import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';
import language from "@lang/language";

const termTextMap = {
	48: language.fourYears,
	36: language.threeYears,
	24: language.twoYears,
	12: language.oneYear
}

const PriceA = ({priceData, showMonthly = false, term = 12, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.containerHolder} ${color ? styles[color] : ''}`}>
		  {priceData.basePrice && (priceData.basePrice !== priceData.price) &&
			<div className={`${styles.oldPrice}`}>{priceData.basePrice} {priceData.text}</div>
		  }

		  <div className={`${styles.container} ${styles.baseLine} ${styles['gap-4-6']}`}>
			  <div className={styles.priceFrom}>
				  {language.from}
			  </div>

			  <div className={`${styles.prices} ${styles['column-gap-4-6']}`}>
				  <div className={`${styles.priceContainer} ${styles.baseLine} ${styles['gap-4-6']}`}>
					  <div className={styles.price}>
						  {priceData.price}
					  </div>
					  <div className={styles.currency}>
						  {priceData.text}
					  </div>
				  </div>
			  </div>
		  </div>

		  {showMonthly === true && term > 1 &&
			<div className={styles.yearPrice}>
				{priceData.priceOriginal} {language.evro} {termTextMap[term]}
			</div>
		  }
	  </div>
	);
}

PriceA.propTypes = {
	priceData: PropTypes.object.isRequired,
	showMonthly: PropTypes.bool,
	term: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	color: PropTypes.string
};

export default PriceA;
